var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "700" } },
        [
          _c("w-card-title", [
            _vm._v(_vm._s(_vm.$ct("carpass-post-observation-description"))),
          ]),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-list" } },
            [
              _c(
                "w-list-item",
                [
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.$ct("carpass-activities"))),
                  ]),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("add-activity"),
                              expression: "$ct('add-activity')",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.addActivity()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "plus" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._l(_vm.result.activities, function (activity, i) {
                return _c(
                  "w-list-item",
                  { key: i },
                  [
                    _c("w-list-item-text", [
                      _vm._v(_vm._s(activity.getText())),
                    ]),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("remove-activity"),
                                expression: "$ct('remove-activity')",
                              },
                            ],
                            staticClass: "danger",
                            on: {
                              click: function ($event) {
                                return _vm.removeActivity(i)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "trash" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c(
                "w-list-item",
                [
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.$ct("carpass-job-descriptions"))),
                  ]),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("add-job-description"),
                              expression: "$ct('add-job-description')",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.addJobDescription()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "plus" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._l(_vm.result.jobDescriptions, function (text, i) {
                return _c(
                  "w-list-item",
                  { key: `jobDescription-${i}` },
                  [
                    _c("w-list-item-text", [_vm._v(_vm._s(text))]),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("edit-job-description"),
                                expression: "$ct('edit-job-description')",
                              },
                            ],
                            staticClass: "warning",
                            on: {
                              click: function ($event) {
                                return _vm.editJobDescription(i)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "pen" } })],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("remove-job-description"),
                                expression: "$ct('remove-job-description')",
                              },
                            ],
                            staticClass: "danger",
                            on: {
                              click: function ($event) {
                                return _vm.removeJobDescription(i)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "trash" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c(
                "w-list-item",
                [
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.$ct("carpass-tire"))),
                  ]),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("add-tire"),
                              expression: "$ct('add-tire')",
                            },
                          ],
                          attrs: { disabled: _vm.addTiresDisabled },
                          on: {
                            click: function ($event) {
                              return _vm.addTire()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "plus" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._l(_vm.result.tyres, function (tire, i) {
                return _c(
                  "w-list-item",
                  { key: `tyre-${i}` },
                  [
                    _c("w-list-item-text", [_vm._v(_vm._s(tire.getText()))]),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("edit-tire"),
                                expression: "$ct('edit-tire')",
                              },
                            ],
                            staticClass: "warning",
                            on: {
                              click: function ($event) {
                                return _vm.editTire(tire)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "pen" } })],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("remove-tire"),
                                expression: "$ct('remove-tire')",
                              },
                            ],
                            staticClass: "danger",
                            on: {
                              click: function ($event) {
                                return _vm.removeTire(i)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "trash" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c("app-carpass-observation-description-add-activity", {
                attrs: { value: _vm.addActivityModalOpen, result: _vm.result },
                on: {
                  close: function ($event) {
                    _vm.addActivityModalOpen = false
                  },
                },
              }),
              _vm.editJobDescripiontOpen
                ? _c(
                    "app-carpass-observation-description-edit-job-description-modal",
                    {
                      attrs: { "to-edit-value": _vm.toEditJobDescriptionValue },
                      on: {
                        input: function ($event) {
                          return _vm.onJobDescriptionInput($event)
                        },
                        close: function ($event) {
                          return _vm.closeJobDescriptionEdit()
                        },
                      },
                    }
                  )
                : _vm._e(),
              _vm.toEditTire
                ? _c("app-carpass-observation-description-tire-edit", {
                    attrs: { tire: _vm.toEditTire },
                    on: {
                      close: function ($event) {
                        _vm.toEditTire = null
                      },
                      input: function ($event) {
                        return _vm.onTire($event)
                      },
                    },
                  })
                : _vm._e(),
              _vm.response
                ? _c("app-carpass-observation-description-response", {
                    attrs: { value: _vm.response },
                    on: {
                      close: function ($event) {
                        _vm.response = null
                      },
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$ct("carpass-description-i-will-do-it-later"))
                  ),
                ]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { disabled: !_vm.isValid, icon: "check" },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }